// Static-transform freeze (Chromebook CPU discipline). three.js recomposes the
// local matrix + world matrix of every object with matrixAutoUpdate=true on
// every frame's updateMatrixWorld() walk. The chunk system already opts its
// instanced world out (freezeStaticObject in chunks.js); this covers the rest:
// zone decor, signposts, terrain meshes — the hundreds of individual meshes
// that never animate via Object3D transforms.
//
// Contract:
// - Builders that DO animate an object's transform (oxen, coins, sprites, quest
//   NPCs…) call markDynamic(group) once at build time; freezeStatics() then
//   skips that whole subtree.
// - The freeze pass only ever touches matrixAutoUpdate — never
//   matrixWorldAutoUpdate — so world-matrix cascades from an animated or
//   exempted ancestor keep propagating, and the editor gizmo keeps working on
//   exempted groups.
// - Anything created AFTER the boot freeze (wolves, eggs, editor spawns)
//   defaults to matrixAutoUpdate=true and is unaffected.

export function markDynamic(obj) {
  obj.userData.dynamic = true;
  return obj;
}

// Walk root, snapshot each static object's local matrix once and opt it out of
// the per-frame recompose. Subtrees under a markDynamic()/exempted node are
// skipped wholesale. Returns how many objects were frozen (logged as [perf]).
export function freezeStatics(root, isExempt = null) {
  let frozen = 0;
  (function walk(o) {
    if (o.userData.dynamic || (isExempt && isExempt(o))) return;
    if (o.matrixAutoUpdate) {
      o.updateMatrix();
      o.matrixAutoUpdate = false;
      frozen++;
    }
    for (const c of o.children) walk(c);
  })(root);
  return frozen;
}

// Re-enable per-frame recompose on one object (e.g. before attaching a gizmo
// to something that was frozen). Position/rotation/scale writes take effect
// again on the next frame.
export function thaw(obj) {
  if (obj) obj.matrixAutoUpdate = true;
}
